// extracted by mini-css-extract-plugin
module.exports = {"title":"ZWzS8i","modal":"_1CqUTF","buttonContainer":"_2ZYHn_"};